// eslint-disable-next-line max-len
import { GlobalDefaultSetting } from '../modules/admin/components/shared/components/global-default-settings/models/global-default-setting.model';
import { ActionSetting } from '../services/dtos/actionSetting';
import { PluginSetting } from '../services/dtos/pluginSetting';
import { SettingFilter } from './components/local-types/SettingFilter';

export class Utils {
  public static getLabelForClose(isEditMode: boolean): string {
    return isEditMode ? 'Cancel' : 'Close';
  }

  public static mapGlobalDefaultSettingToListItem(
    globalDefaultSettings: GlobalDefaultSetting[]
  ): SettingFilter[] {
    return globalDefaultSettings.map((x, index) => ({
      id: index++,
      name: x.key,
      displayName: x.displayName
    })) as SettingFilter[];
  }

  public static mapGlobalDefaultSettingsToPluginSettings(globalDefaultSettings: GlobalDefaultSetting[]): PluginSetting[] {
    return globalDefaultSettings.map((x) => ({
      id: x.id,
      key: x.key,
      value: x.value
    })) as PluginSetting[];
  }

  public static mapGlobalDefaultSettingsToActionSettings(globalDefaultSettings: GlobalDefaultSetting[]): ActionSetting[] {
    return globalDefaultSettings.map((x) => ({
      id: x.id,
      key: x.key,
      value: x.value,
      displayName: '',
      settingType: '',
      typeValues: [],
      isSensitive: false,
      moveNextSettingToNewLine: false,
      columnsAmount: 0
    })) as ActionSetting[];
  }

  // '-' in the field name will order that property by descending
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static fieldSorter = (fields: string[]) => (a: any, b: any) =>
    fields
      .map((o: string) => {
        let orderType = 1;

        if (o[0] === '-') {
          orderType = -1;
          o = o.substring(1);
        }

        if (a[o] === null) {
          return -1;
        }

        if (b[o] === null) {
          return 1;
        }

        if (typeof a[o] === 'string') {
          return this.getStringElementsComparisonValue(a, o, b, orderType);
        }

        return this.getElementsComparisonValue(a, o, b, orderType);
      })
      .reduce((p, n) => (p ? p : n), 0);

   // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private static getElementsComparisonValue(a: any, o: string, b: any, orderType: number): number {
    return a[o] > b[o] ? orderType : a[o] < b[o] ? -orderType : 0;
  }
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private static getStringElementsComparisonValue(a: any, o: string, b: any, orderType: number): number {
    return a[o].toLowerCase() > b[o].toLowerCase()
      ? orderType
      : a[o].toLowerCase() < b[o].toLowerCase()
        ? -orderType
        : 0;
  }
}
